import { Mail } from '@strapi/icons';
import { PLUGIN_ID } from './pluginId';
import { prefixPluginTranslations } from './utils/getTrad';
import Initializer from './components/Initializer';

const name = 'EasyEmail';

export default {
  register(app: any) {
    app.addMenuLink({
      to: `plugins/${PLUGIN_ID}`,
      icon: Mail,
      intlLabel: {
        id: `${PLUGIN_ID}.plugin.name`,
        defaultMessage: name,
      },
      Component: () =>
        import('./pages/App').then((mod) => ({ default: mod.App })),
      permissions: [
        { action: `plugin::${PLUGIN_ID}.read`, subject: null },
      ],
    });

    app.registerPlugin({
      id: PLUGIN_ID,
      initializer: Initializer,
      isReady: false,
      name,
    });
  },

  bootstrap() {},

  async registerTrads({ locales }: { locales: string[] }) {
    return Promise.all(
      locales.map(async (locale) => {
        try {
          const { default: data } = await import(`./translations/${locale}.json`);
          return {
            data: prefixPluginTranslations(data, PLUGIN_ID),
            locale,
          };
        } catch {
          return {
            data: {},
            locale,
          };
        }
      })
    );
  },
};
